import React from "react";
import { Navigate } from "react-router-dom";

const aboutData = [
    {
        title: "Who We Are",
        content:
            "MINIX IT HUB Pvt. Ltd. is a leading IT solutions provider, delivering innovative and customized technology services to clients worldwide. Our team of experts is dedicated to transforming your ideas into reality with cutting-edge solutions."
    },
    {
        title: "Our Mission",
        content:
            "To empower businesses with reliable, scalable, and cost-effective IT solutions that drive growth and success in the digital era."
    },
    {
        title: "Our Vision",
        content:
            "To be a global leader in IT services, recognized for our commitment to quality, innovation, and customer satisfaction."
    },
    {
        title: "What We Do",
        content:
            "We offer a wide range of services including Web Development, Mobile App Development, UI/UX Design, Digital Marketing, and IT Consulting. Our solutions are tailored to meet the unique needs of each client."
    }
];

const teamMembers = [
    {
        name: "Ashish Soni",
        role: "Founder & CEO",
        img: "/images/ashishsoni.png"
    },
    {
        name: "Guru Charan Soni",
        role: "Founder",
        img: "/images/Gurucharansoni.png"
    }
    // Add more team members as needed
];

const AboutUs = () => {
    
    return (
        <div
            style={{
                fontFamily: "Segoe UI, sans-serif",
                background: "linear-gradient(135deg, #f8fafc 0%, #e0e7ef 100%)",
                minHeight: "100vh",
                padding: "0"
            }}
        >
            <header
                style={{
                    background: "linear-gradient(90deg, #1e3c72 0%, #2a5298 100%)",
                    color: "#fff",
                    padding: "60px 0 40px 0",
                    textAlign: "center",
                    boxShadow: "0 4px 24px rgba(30,60,114,0.15)"
                }}
            >
                <h1 style={{ fontSize: "2.8rem", margin: 0, letterSpacing: "2px" }}>
                    About Us
                </h1>
                <p style={{ fontSize: "1.3rem", marginTop: "16px", opacity: 0.9 }}>
                    MINIX IT HUB Pvt. Ltd. – Innovating Your Digital Future
                </p>
            </header>

            <main style={{ maxWidth: 1100, margin: "0 auto", padding: "40px 20px" }}>
                <section
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(420px, 1fr))",
                        gap: "32px"
                    }}
                >
                    {aboutData.map((item, idx) => (
                        <div
                            key={idx}
                            style={{
                                background: "#fff",
                                borderRadius: "18px",
                                boxShadow: "0 2px 16px rgba(30,60,114,0.07)",
                                padding: "32px 28px",
                                transition: "transform 0.2s, box-shadow 0.2s",
                                willChange: "transform",
                                cursor: "pointer"
                            }}
                            onMouseOver={e => {
                                e.currentTarget.style.transform = "translateY(-6px) scale(1.03)";
                                e.currentTarget.style.boxShadow =
                                    "0 8px 32px rgba(30,60,114,0.13)";
                            }}
                            onMouseOut={e => {
                                e.currentTarget.style.transform = "none";
                                e.currentTarget.style.boxShadow =
                                    "0 2px 16px rgba(30,60,114,0.07)";
                            }}
                        >
                            <h2
                                style={{
                                    color: "#1e3c72",
                                    fontSize: "1.5rem",
                                    marginBottom: "12px"
                                }}
                            >
                                {item.title}
                            </h2>
                            <p style={{ color: "#444", fontSize: "1.08rem", lineHeight: 1.7 }}>
                                {item.content}
                            </p>
                        </div>
                    ))}
                </section>

                <section style={{ marginTop: 60 }}>
                    <h2
                        style={{
                            color: "#2a5298",
                            fontSize: "2rem",
                            textAlign: "center",
                            marginBottom: "32px"
                        }}
                    >
                        Meet Our Leadership
                    </h2>
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            gap: "36px"
                        }}
                    >
                        {teamMembers.map((member, idx) => (
                            <div
                                key={idx}
                                style={{
                                    background: "#fff",
                                    borderRadius: "16px",
                                    boxShadow: "0 2px 16px rgba(30,60,114,0.09)",
                                    padding: "24px 18px",
                                    textAlign: "center",
                                    width: 220,
                                    transition: "box-shadow 0.2s"
                                }}
                            >
                                <img
                                    src={member.img}
                                    alt={member.name}
                                    style={{
                                        width: 120,
                                        height: 120,
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                        marginBottom: 16,
                                        border: "4px solid #e0e7ef"
                                    }}
                                />
                                <h3 style={{ margin: "0 0 6px 0", color: "#1e3c72" }}>
                                    {member.name}
                                </h3>
                                <p style={{ color: "#666", fontSize: "1rem" }}>{member.role}</p>
                            </div>
                        ))}
                    </div>
                </section>

                <section
                    style={{
                        marginTop: 70,
                        background: "linear-gradient(90deg, #1e3c72 0%, #2a5298 100%)",
                        borderRadius: "18px",
                        color: "#fff",
                        padding: "36px 28px",
                        textAlign: "center",
                        boxShadow: "0 2px 16px rgba(30,60,114,0.10)"
                    }}
                >
                    <h2 style={{ fontSize: "1.7rem", marginBottom: 12 }}>
                        Ready to Transform Your Business?
                    </h2>
                    <p style={{ fontSize: "1.1rem", marginBottom: 18 }}>
                        Partner with MINIX IT HUB Pvt. Ltd. for innovative, reliable, and scalable IT solutions.
                    </p>
                    <a
                        href="/contact"
                        style={{
                            display: "inline-block",
                            background: "#fff",
                            color: "#1e3c72",
                            padding: "12px 32px",
                            borderRadius: "8px",
                            fontWeight: 600,
                            textDecoration: "none",
                            fontSize: "1.1rem",
                            boxShadow: "0 2px 8px rgba(30,60,114,0.08)",
                            transition: "background 0.2s, color 0.2s"
                        }}
                        onMouseOver={e => {
                            e.currentTarget.style.background = "#2a5298";
                            e.currentTarget.style.color = "#fff";
                        }}
                        onMouseOut={e => {
                            e.currentTarget.style.background = "#fff";
                            e.currentTarget.style.color = "#1e3c72";
                        }}
                    >
                        Contact Us
                    </a>
                </section>
            </main>
        </div>
    );
};

export default AboutUs;